export default __webpack_public_path__ + "static/media/StudentRoleIcon.e0768b17.svg";